export default {"src":"/_next/static/media/footer-sitter.acbf2d88.svg","height":261,"width":477,"blurWidth":0,"blurHeight":0};